export function isEmptyObject<T extends Record<string, unknown>>(
  obj: T
): boolean {
  if (obj === null || typeof obj !== 'object') {
    return true;
  }

  return Object.keys(obj).length === 0;
}
